import { gql } from '@apollo/client';
export const UpdateAllowStaffAbsencesOnWeekend = gql `
    mutation UpdateAllowStaffAbsencesOnWeekend($siteSetId: InstitutionSetId!, $allowStaffAbsencesOnWeekend: Boolean) {
        staffhours {
            settings {
                updateAllowStaffAbsencesOnWeekend(
                    siteSetId: $siteSetId
                    allowStaffAbsencesOnWeekend: $allowStaffAbsencesOnWeekend
                )
            }
        }
    }
`;
